import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

import {GetHanjaHtml, SetHunHightlight} from "../../defines/client.func";
import {GetSaseungTxt} from "../../defines/gukeo.func";
import {Saseung, SaseungHanja} from "../../models/saseung.model";

@Component({
  selector: 'app-hun-hanja-item',
  styleUrls: ['./hun-hanja-item.component.scss'],
  template: `
    <div class="hanja" [innerHTML]="GetHanjaHtml(hanja.hanja) | keepHtml"></div>
    <div class="saseung-list">
      <div class="saseung-box" *ngFor="let saseung of hanja.saseungs">
        <div class="saseung">{{ GetSaseungTxt(saseung.saseung) }}</div>
        <div class="meaning" [innerHTML]="GetMeaning(saseung) | resize | keepHtml"></div>
      </div>
    </div>
  `,
})
export class HunHanjaItemComponent implements AfterViewInit {
  @Input() hun: string;
  @Input() hanja: SaseungHanja;
  @Output() afterViewInit = new EventEmitter<void>();

  public readonly GetHanjaHtml = GetHanjaHtml;
  protected readonly GetSaseungTxt = GetSaseungTxt;


  constructor() { }

  ngAfterViewInit() {
    this.afterViewInit.emit();
  }

  protected GetMeaning(saseung: Saseung) {
    return SetHunHightlight(saseung.meaning, this.hun!) + ` <b>${saseung.hangul}</b>`;
  }
}
